var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1149,
    height: 116,
    viewBox: "0 0 1149 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3046_1359)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter0_f_3046_1359)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 854.119,
    cy: 134.881,
    r: 294.881,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    filter: "url(#filter1_f_3046_1359)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 234.881,
    cy: 224.881,
    r: 294.881,
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-231.654 -22.7238C-253.858 -80.2819 -248.968 -118.296 -231.561 -136.321C-214.154 -154.346 -176.334 -160.561 -118.036 -140.379C-62.0051 -120.982 3.93468 -79.7256 65.3838 -20.3849C126.833 38.9558 170.365 103.416 191.706 158.735C213.91 216.293 209.019 254.308 191.613 272.333C174.206 290.358 136.386 296.572 78.0878 276.39C22.057 256.993 -43.8828 215.737 -105.332 156.396C-166.781 97.0557 -210.313 32.5959 -231.654 -22.7238ZM-245.058 -149.356C-270.598 -122.909 -271.911 -74.9459 -249.16 -15.9705C-226.632 42.4261 -181.324 109.096 -118.366 169.894C-55.4084 230.691 12.8023 273.645 71.9495 294.121C131.683 314.8 179.571 311.814 205.11 285.367C230.65 258.92 231.963 210.957 209.212 151.982C186.684 93.5854 141.376 26.9153 78.418 -33.8822C15.4603 -94.6798 -52.7505 -137.634 -111.898 -158.11C-171.631 -178.789 -219.519 -175.803 -245.058 -149.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M185.348 -25.1727C207.324 -82.138 201.204 -116.598 186.705 -131.613C172.205 -146.628 137.98 -153.946 80.2821 -133.972C25.3784 -114.965 -39.7401 -74.3225 -100.643 -15.509C-161.547 43.3046 -204.436 106.965 -225.348 161.172C-247.324 218.137 -241.204 252.597 -226.705 267.612C-212.205 282.627 -177.98 289.945 -120.282 269.971C-65.3784 250.964 -0.259935 210.322 60.6433 151.508C121.547 92.6946 164.436 29.0342 185.348 -25.1727ZM83.1066 174.77C210.113 52.1205 266.91 -95.1088 209.966 -154.076C153.022 -213.044 3.90028 -161.42 -123.107 -38.7704C-250.113 83.8787 -306.91 231.108 -249.966 290.075C-193.022 349.043 -43.9002 297.419 83.1066 174.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M968.346 -22.7238C946.142 -80.2819 951.033 -118.296 968.439 -136.321C985.846 -154.346 1023.67 -160.561 1081.96 -140.379C1137.99 -120.982 1203.93 -79.7256 1265.38 -20.3849C1326.83 38.9558 1370.37 103.416 1391.71 158.735C1413.91 216.293 1409.02 254.308 1391.61 272.333C1374.21 290.358 1336.39 296.572 1278.09 276.39C1222.06 256.993 1156.12 215.737 1094.67 156.396C1033.22 97.0557 989.687 32.5959 968.346 -22.7238ZM954.942 -149.356C929.402 -122.909 928.089 -74.9459 950.84 -15.9705C973.368 42.4261 1018.68 109.096 1081.63 169.894C1144.59 230.691 1212.8 273.645 1271.95 294.121C1331.68 314.8 1379.57 311.814 1405.11 285.367C1430.65 258.92 1431.96 210.957 1409.21 151.982C1386.68 93.5854 1341.38 26.9153 1278.42 -33.8822C1215.46 -94.6798 1147.25 -137.634 1088.1 -158.11C1028.37 -178.789 980.481 -175.803 954.942 -149.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1385.35 -25.1727C1407.32 -82.138 1401.2 -116.598 1386.7 -131.613C1372.21 -146.628 1337.98 -153.946 1280.28 -133.972C1225.38 -114.965 1160.26 -74.3225 1099.36 -15.509C1038.45 43.3046 995.564 106.965 974.652 161.172C952.676 218.137 958.796 252.597 973.295 267.612C987.795 282.627 1022.02 289.945 1079.72 269.971C1134.62 250.964 1199.74 210.322 1260.64 151.508C1321.55 92.6946 1364.44 29.0342 1385.35 -25.1727ZM1283.11 174.77C1410.11 52.1205 1466.91 -95.1088 1409.97 -154.076C1353.02 -213.044 1203.9 -161.42 1076.89 -38.7704C949.887 83.8787 893.09 231.108 950.034 290.075C1006.98 349.043 1156.1 297.419 1283.11 174.77Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M368.346 -22.7238C346.142 -80.2819 351.033 -118.296 368.439 -136.321C385.846 -154.346 423.666 -160.561 481.964 -140.379C537.995 -120.982 603.935 -79.7256 665.384 -20.3849C726.833 38.9558 770.365 103.416 791.706 158.735C813.91 216.293 809.02 254.308 791.613 272.333C774.206 290.358 736.386 296.572 678.088 276.39C622.057 256.993 556.117 215.737 494.668 156.396C433.219 97.0557 389.687 32.5959 368.346 -22.7238ZM354.942 -149.356C329.402 -122.909 328.089 -74.9459 350.84 -15.9705C373.368 42.4261 418.676 109.096 481.634 169.894C544.592 230.691 612.802 273.645 671.95 294.121C731.683 314.8 779.571 311.814 805.11 285.367C830.65 258.92 831.963 210.957 809.212 151.982C786.684 93.5854 741.376 26.9153 678.418 -33.8822C615.46 -94.6798 547.25 -137.634 488.102 -158.11C428.369 -178.789 380.481 -175.803 354.942 -149.356Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M785.348 -25.1727C807.324 -82.138 801.204 -116.598 786.705 -131.613C772.205 -146.628 737.98 -153.946 680.282 -133.972C625.378 -114.965 560.26 -74.3225 499.357 -15.509C438.454 43.3046 395.564 106.965 374.652 161.172C352.676 218.137 358.796 252.597 373.295 267.612C387.795 282.627 422.02 289.945 479.718 269.971C534.622 250.964 599.74 210.322 660.643 151.508C721.547 92.6946 764.437 29.0342 785.348 -25.1727ZM683.107 174.77C810.114 52.1205 866.911 -95.1088 809.966 -154.076C753.022 -213.044 603.9 -161.42 476.893 -38.7704C349.887 83.8787 293.09 231.108 350.034 290.075C406.978 349.043 556.1 297.419 683.107 174.77Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3046_1359",
    x: 281.261,
    y: -437.977,
    width: 1145.72,
    height: 1145.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.989,
    result: "effect1_foregroundBlur_3046_1359"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_3046_1359",
    x: -337.977,
    y: -347.977,
    width: 1145.72,
    height: 1145.72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 138.989,
    result: "effect1_foregroundBlur_3046_1359"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3046_1359"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1149,
    height: 116,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackground);
export default __webpack_public_path__ + "static/media/background.8b32295093da70becee6c7d41fb3c75a.svg";
export { ForwardRef as ReactComponent };